var precisionMedium = "\nprecision mediump float;\n";
export default precisionMedium.replace(/\n/g, '');